import { gameService } from "../../data/gameService";
import { useParams } from "react-router-dom";
import { useSupabase } from "../../auth/useSupabase";
import { Tables } from "../../../database.types";
import { useState, useEffect } from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import GameEditor from "./GameEditor";
import GameBoardEditor from "./GameBoardEditor";

const GameBuilder = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const theme = useTheme();
  const { supabase, user } = useSupabase();
  const [loading, setLoading] = useState(true);
  const [game, setGame] = useState<Tables<"games"> | null>(null);

  useEffect(() => {
    if (gameId) {
      gameService
        .getById(supabase, gameId)
        .then(setGame)
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [gameId, supabase]);

  if (loading) {
    return (
      <Box
        height="100vh"
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={theme.palette.primary.dark}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!game) {
    return (
      <Box
        height="100vh"
        width="100vw"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography>Game not found</Typography>
      </Box>
    );
  }

  if (!user || user.id !== game.creator_id) {
    return (
      <Box
        height="100vh"
        width="100vw"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography>Unauthorized</Typography>
      </Box>
    );
  }

  const disabled = !!(game.is_started || game.creator_id !== user.id);

  return (
    <Box
      height="calc(100vh - 32px)"
      width="calc(100% - 32px)"
      overflow="hidden"
      p="16px"
      bgcolor={theme.palette.primary.dark}
      display="flex"
      flexDirection="column"
      gap="8px"
    >
      <GameEditor gameId={game.id} leagueId={game.league_id} />
      <GameBoardEditor gameId={game.id} disabled={disabled} />
    </Box>
  );
};

export default GameBuilder;
